export const checkboxTheme = {
  baseStyle: {
    control: {
      border: '1px solid',
      borderColor: 'grey.400',
      _checked: {
        bg: 'primaryColor',
        _hover: {
          bg: 'primaryColor_hover',
        },
      },
      _hover: {
        bg: { sm: 'transparent', md: 'primaryColor_opacity' },
      },
    },
    label: {
      marginLeft: 3,
    },
  },
  sizes: {
    md: {
      control: {
        boxSize: '17px',
      },
    },
  },
};
